export default __webpack_public_path__ + "static/living_cover-167d09118bd95b90132e5951d4ebc101.png";